/* eslint-disable */
// source: vivacity/core/zonal_features.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var vivacity_core_classifying_detector_class_types_pb = require('../../vivacity/core/classifying_detector_class_types_pb.js');
goog.object.extend(proto, vivacity_core_classifying_detector_class_types_pb);
var vivacity_core_tracing_context_pb = require('../../vivacity/core/tracing_context_pb.js');
goog.object.extend(proto, vivacity_core_tracing_context_pb);
var vivacity_core_vector_pb = require('../../vivacity/core/vector_pb.js');
goog.object.extend(proto, vivacity_core_vector_pb);
var vivacity_core_movement_pb = require('../../vivacity/core/movement_pb.js');
goog.object.extend(proto, vivacity_core_movement_pb);
goog.exportSymbol('proto.vivacity.core.ClassFeatures', null, global);
goog.exportSymbol('proto.vivacity.core.ZonalFeatures', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.core.ZonalFeatures = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vivacity.core.ZonalFeatures.repeatedFields_, null);
};
goog.inherits(proto.vivacity.core.ZonalFeatures, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.core.ZonalFeatures.displayName = 'proto.vivacity.core.ZonalFeatures';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.core.ClassFeatures = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vivacity.core.ClassFeatures, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.core.ClassFeatures.displayName = 'proto.vivacity.core.ClassFeatures';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vivacity.core.ZonalFeatures.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.core.ZonalFeatures.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.core.ZonalFeatures.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.core.ZonalFeatures} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.ZonalFeatures.toObject = function(includeInstance, msg) {
  var f, obj = {
    visionProgramId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    zoneId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    timestampMicro: jspb.Message.getFieldWithDefault(msg, 3, 0),
    classFeaturesList: jspb.Message.toObjectList(msg.getClassFeaturesList(),
    proto.vivacity.core.ClassFeatures.toObject, includeInstance),
    aggregatedOccupancy: jspb.Message.getFieldWithDefault(msg, 6, 0),
    aggregatedCrossingsClockwise: jspb.Message.getFieldWithDefault(msg, 7, 0),
    aggregatedCrossingsAnticlockwise: jspb.Message.getFieldWithDefault(msg, 8, 0),
    averageDistanceScalar: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    averageDisplacement: (f = msg.getAverageDisplacement()) && vivacity_core_vector_pb.Vector.toObject(includeInstance, f),
    aggregatedStoppedVehiclesCount: jspb.Message.getFieldWithDefault(msg, 11, 0),
    averageMovement: (f = msg.getAverageMovement()) && vivacity_core_movement_pb.Movement.toObject(includeInstance, f),
    tracingCtx: (f = msg.getTracingCtx()) && vivacity_core_tracing_context_pb.TracingContext.toObject(includeInstance, f),
    aggregatedCumulativeStoppedFrames: jspb.Message.getFieldWithDefault(msg, 13, 0),
    aggregatedDirectionalOccupancy: jspb.Message.getFieldWithDefault(msg, 14, 0),
    aggregatedContraDirectionalOccupancy: jspb.Message.getFieldWithDefault(msg, 15, 0),
    aggregatedStoppedDirectionalVehiclesCount: jspb.Message.getFieldWithDefault(msg, 16, 0),
    aggregatedStoppedContraDirectionalVehiclesCount: jspb.Message.getFieldWithDefault(msg, 17, 0),
    aggregatedCumulativeStoppedDirectionalFrames: jspb.Message.getFieldWithDefault(msg, 18, 0),
    aggregatedCumulativeStoppedContraDirectionalFrames: jspb.Message.getFieldWithDefault(msg, 19, 0),
    aggregatedCumulativeStoppedMicroseconds: jspb.Message.getFieldWithDefault(msg, 20, 0),
    aggregatedCumulativeStoppedDirectionalMicroseconds: jspb.Message.getFieldWithDefault(msg, 21, 0),
    aggregatedCumulativeStoppedContraDirectionalMicroseconds: jspb.Message.getFieldWithDefault(msg, 22, 0),
    occlusionPct: jspb.Message.getFieldWithDefault(msg, 23, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.core.ZonalFeatures}
 */
proto.vivacity.core.ZonalFeatures.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.core.ZonalFeatures;
  return proto.vivacity.core.ZonalFeatures.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.core.ZonalFeatures} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.core.ZonalFeatures}
 */
proto.vivacity.core.ZonalFeatures.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVisionProgramId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setZoneId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimestampMicro(value);
      break;
    case 4:
      var value = new proto.vivacity.core.ClassFeatures;
      reader.readMessage(value,proto.vivacity.core.ClassFeatures.deserializeBinaryFromReader);
      msg.addClassFeatures(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAggregatedOccupancy(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAggregatedCrossingsClockwise(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAggregatedCrossingsAnticlockwise(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAverageDistanceScalar(value);
      break;
    case 10:
      var value = new vivacity_core_vector_pb.Vector;
      reader.readMessage(value,vivacity_core_vector_pb.Vector.deserializeBinaryFromReader);
      msg.setAverageDisplacement(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAggregatedStoppedVehiclesCount(value);
      break;
    case 12:
      var value = new vivacity_core_movement_pb.Movement;
      reader.readMessage(value,vivacity_core_movement_pb.Movement.deserializeBinaryFromReader);
      msg.setAverageMovement(value);
      break;
    case 5:
      var value = new vivacity_core_tracing_context_pb.TracingContext;
      reader.readMessage(value,vivacity_core_tracing_context_pb.TracingContext.deserializeBinaryFromReader);
      msg.setTracingCtx(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAggregatedCumulativeStoppedFrames(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAggregatedDirectionalOccupancy(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAggregatedContraDirectionalOccupancy(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAggregatedStoppedDirectionalVehiclesCount(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAggregatedStoppedContraDirectionalVehiclesCount(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAggregatedCumulativeStoppedDirectionalFrames(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAggregatedCumulativeStoppedContraDirectionalFrames(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAggregatedCumulativeStoppedMicroseconds(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAggregatedCumulativeStoppedDirectionalMicroseconds(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAggregatedCumulativeStoppedContraDirectionalMicroseconds(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOcclusionPct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.core.ZonalFeatures.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.core.ZonalFeatures.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.core.ZonalFeatures} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.ZonalFeatures.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVisionProgramId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getZoneId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getTimestampMicro();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getClassFeaturesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.vivacity.core.ClassFeatures.serializeBinaryToWriter
    );
  }
  f = message.getAggregatedOccupancy();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getAggregatedCrossingsClockwise();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getAggregatedCrossingsAnticlockwise();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getAverageDistanceScalar();
  if (f !== 0.0) {
    writer.writeFloat(
      9,
      f
    );
  }
  f = message.getAverageDisplacement();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      vivacity_core_vector_pb.Vector.serializeBinaryToWriter
    );
  }
  f = message.getAggregatedStoppedVehiclesCount();
  if (f !== 0) {
    writer.writeUint32(
      11,
      f
    );
  }
  f = message.getAverageMovement();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      vivacity_core_movement_pb.Movement.serializeBinaryToWriter
    );
  }
  f = message.getTracingCtx();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      vivacity_core_tracing_context_pb.TracingContext.serializeBinaryToWriter
    );
  }
  f = message.getAggregatedCumulativeStoppedFrames();
  if (f !== 0) {
    writer.writeUint32(
      13,
      f
    );
  }
  f = message.getAggregatedDirectionalOccupancy();
  if (f !== 0) {
    writer.writeUint32(
      14,
      f
    );
  }
  f = message.getAggregatedContraDirectionalOccupancy();
  if (f !== 0) {
    writer.writeUint32(
      15,
      f
    );
  }
  f = message.getAggregatedStoppedDirectionalVehiclesCount();
  if (f !== 0) {
    writer.writeUint32(
      16,
      f
    );
  }
  f = message.getAggregatedStoppedContraDirectionalVehiclesCount();
  if (f !== 0) {
    writer.writeUint32(
      17,
      f
    );
  }
  f = message.getAggregatedCumulativeStoppedDirectionalFrames();
  if (f !== 0) {
    writer.writeUint32(
      18,
      f
    );
  }
  f = message.getAggregatedCumulativeStoppedContraDirectionalFrames();
  if (f !== 0) {
    writer.writeUint32(
      19,
      f
    );
  }
  f = message.getAggregatedCumulativeStoppedMicroseconds();
  if (f !== 0) {
    writer.writeUint32(
      20,
      f
    );
  }
  f = message.getAggregatedCumulativeStoppedDirectionalMicroseconds();
  if (f !== 0) {
    writer.writeUint32(
      21,
      f
    );
  }
  f = message.getAggregatedCumulativeStoppedContraDirectionalMicroseconds();
  if (f !== 0) {
    writer.writeUint32(
      22,
      f
    );
  }
  f = message.getOcclusionPct();
  if (f !== 0) {
    writer.writeUint32(
      23,
      f
    );
  }
};


/**
 * optional uint32 vision_program_id = 1;
 * @return {number}
 */
proto.vivacity.core.ZonalFeatures.prototype.getVisionProgramId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.setVisionProgramId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 zone_id = 2;
 * @return {number}
 */
proto.vivacity.core.ZonalFeatures.prototype.getZoneId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.setZoneId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 timestamp_micro = 3;
 * @return {number}
 */
proto.vivacity.core.ZonalFeatures.prototype.getTimestampMicro = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.setTimestampMicro = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated ClassFeatures class_features = 4;
 * @return {!Array<!proto.vivacity.core.ClassFeatures>}
 */
proto.vivacity.core.ZonalFeatures.prototype.getClassFeaturesList = function() {
  return /** @type{!Array<!proto.vivacity.core.ClassFeatures>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vivacity.core.ClassFeatures, 4));
};


/**
 * @param {!Array<!proto.vivacity.core.ClassFeatures>} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
*/
proto.vivacity.core.ZonalFeatures.prototype.setClassFeaturesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.vivacity.core.ClassFeatures=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vivacity.core.ClassFeatures}
 */
proto.vivacity.core.ZonalFeatures.prototype.addClassFeatures = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.vivacity.core.ClassFeatures, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.clearClassFeaturesList = function() {
  return this.setClassFeaturesList([]);
};


/**
 * optional uint32 aggregated_occupancy = 6;
 * @return {number}
 */
proto.vivacity.core.ZonalFeatures.prototype.getAggregatedOccupancy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.setAggregatedOccupancy = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 aggregated_crossings_clockwise = 7;
 * @return {number}
 */
proto.vivacity.core.ZonalFeatures.prototype.getAggregatedCrossingsClockwise = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.setAggregatedCrossingsClockwise = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 aggregated_crossings_anticlockwise = 8;
 * @return {number}
 */
proto.vivacity.core.ZonalFeatures.prototype.getAggregatedCrossingsAnticlockwise = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.setAggregatedCrossingsAnticlockwise = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional float average_distance_scalar = 9;
 * @return {number}
 */
proto.vivacity.core.ZonalFeatures.prototype.getAverageDistanceScalar = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.setAverageDistanceScalar = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional Vector average_displacement = 10;
 * @return {?proto.vivacity.core.Vector}
 */
proto.vivacity.core.ZonalFeatures.prototype.getAverageDisplacement = function() {
  return /** @type{?proto.vivacity.core.Vector} */ (
    jspb.Message.getWrapperField(this, vivacity_core_vector_pb.Vector, 10));
};


/**
 * @param {?proto.vivacity.core.Vector|undefined} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
*/
proto.vivacity.core.ZonalFeatures.prototype.setAverageDisplacement = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.clearAverageDisplacement = function() {
  return this.setAverageDisplacement(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.core.ZonalFeatures.prototype.hasAverageDisplacement = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional uint32 aggregated_stopped_vehicles_count = 11;
 * @return {number}
 */
proto.vivacity.core.ZonalFeatures.prototype.getAggregatedStoppedVehiclesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.setAggregatedStoppedVehiclesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional Movement average_movement = 12;
 * @return {?proto.vivacity.core.Movement}
 */
proto.vivacity.core.ZonalFeatures.prototype.getAverageMovement = function() {
  return /** @type{?proto.vivacity.core.Movement} */ (
    jspb.Message.getWrapperField(this, vivacity_core_movement_pb.Movement, 12));
};


/**
 * @param {?proto.vivacity.core.Movement|undefined} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
*/
proto.vivacity.core.ZonalFeatures.prototype.setAverageMovement = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.clearAverageMovement = function() {
  return this.setAverageMovement(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.core.ZonalFeatures.prototype.hasAverageMovement = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional TracingContext tracing_ctx = 5;
 * @return {?proto.vivacity.core.TracingContext}
 */
proto.vivacity.core.ZonalFeatures.prototype.getTracingCtx = function() {
  return /** @type{?proto.vivacity.core.TracingContext} */ (
    jspb.Message.getWrapperField(this, vivacity_core_tracing_context_pb.TracingContext, 5));
};


/**
 * @param {?proto.vivacity.core.TracingContext|undefined} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
*/
proto.vivacity.core.ZonalFeatures.prototype.setTracingCtx = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.clearTracingCtx = function() {
  return this.setTracingCtx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.core.ZonalFeatures.prototype.hasTracingCtx = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional uint32 aggregated_cumulative_stopped_frames = 13;
 * @return {number}
 */
proto.vivacity.core.ZonalFeatures.prototype.getAggregatedCumulativeStoppedFrames = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.setAggregatedCumulativeStoppedFrames = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional uint32 aggregated_directional_occupancy = 14;
 * @return {number}
 */
proto.vivacity.core.ZonalFeatures.prototype.getAggregatedDirectionalOccupancy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.setAggregatedDirectionalOccupancy = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional uint32 aggregated_contra_directional_occupancy = 15;
 * @return {number}
 */
proto.vivacity.core.ZonalFeatures.prototype.getAggregatedContraDirectionalOccupancy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.setAggregatedContraDirectionalOccupancy = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional uint32 aggregated_stopped_directional_vehicles_count = 16;
 * @return {number}
 */
proto.vivacity.core.ZonalFeatures.prototype.getAggregatedStoppedDirectionalVehiclesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.setAggregatedStoppedDirectionalVehiclesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional uint32 aggregated_stopped_contra_directional_vehicles_count = 17;
 * @return {number}
 */
proto.vivacity.core.ZonalFeatures.prototype.getAggregatedStoppedContraDirectionalVehiclesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.setAggregatedStoppedContraDirectionalVehiclesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional uint32 aggregated_cumulative_stopped_directional_frames = 18;
 * @return {number}
 */
proto.vivacity.core.ZonalFeatures.prototype.getAggregatedCumulativeStoppedDirectionalFrames = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.setAggregatedCumulativeStoppedDirectionalFrames = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional uint32 aggregated_cumulative_stopped_contra_directional_frames = 19;
 * @return {number}
 */
proto.vivacity.core.ZonalFeatures.prototype.getAggregatedCumulativeStoppedContraDirectionalFrames = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.setAggregatedCumulativeStoppedContraDirectionalFrames = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional uint32 aggregated_cumulative_stopped_microseconds = 20;
 * @return {number}
 */
proto.vivacity.core.ZonalFeatures.prototype.getAggregatedCumulativeStoppedMicroseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.setAggregatedCumulativeStoppedMicroseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional uint32 aggregated_cumulative_stopped_directional_microseconds = 21;
 * @return {number}
 */
proto.vivacity.core.ZonalFeatures.prototype.getAggregatedCumulativeStoppedDirectionalMicroseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.setAggregatedCumulativeStoppedDirectionalMicroseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional uint32 aggregated_cumulative_stopped_contra_directional_microseconds = 22;
 * @return {number}
 */
proto.vivacity.core.ZonalFeatures.prototype.getAggregatedCumulativeStoppedContraDirectionalMicroseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.setAggregatedCumulativeStoppedContraDirectionalMicroseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional uint32 occlusion_pct = 23;
 * @return {number}
 */
proto.vivacity.core.ZonalFeatures.prototype.getOcclusionPct = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ZonalFeatures} returns this
 */
proto.vivacity.core.ZonalFeatures.prototype.setOcclusionPct = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.core.ClassFeatures.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.core.ClassFeatures.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.core.ClassFeatures} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.ClassFeatures.toObject = function(includeInstance, msg) {
  var f, obj = {
    classType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    occupancy: jspb.Message.getFieldWithDefault(msg, 2, 0),
    crossingsClockwise: jspb.Message.getFieldWithDefault(msg, 3, 0),
    crossingsAnticlockwise: jspb.Message.getFieldWithDefault(msg, 4, 0),
    averageDistanceScalar: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    averageDisplacement: (f = msg.getAverageDisplacement()) && vivacity_core_vector_pb.Vector.toObject(includeInstance, f),
    stoppedVehiclesCount: jspb.Message.getFieldWithDefault(msg, 7, 0),
    averageMovement: (f = msg.getAverageMovement()) && vivacity_core_movement_pb.Movement.toObject(includeInstance, f),
    cumulativeStoppedFrames: jspb.Message.getFieldWithDefault(msg, 9, 0),
    directionalOccupancy: jspb.Message.getFieldWithDefault(msg, 10, 0),
    contraDirectionalOccupancy: jspb.Message.getFieldWithDefault(msg, 11, 0),
    stoppedDirectionalVehiclesCount: jspb.Message.getFieldWithDefault(msg, 12, 0),
    stoppedContraDirectionalVehiclesCount: jspb.Message.getFieldWithDefault(msg, 13, 0),
    cumulativeStoppedDirectionalFrames: jspb.Message.getFieldWithDefault(msg, 14, 0),
    cumulativeStoppedContraDirectionalFrames: jspb.Message.getFieldWithDefault(msg, 15, 0),
    cumulativeStoppedMicroseconds: jspb.Message.getFieldWithDefault(msg, 16, 0),
    cumulativeStoppedDirectionalMicroseconds: jspb.Message.getFieldWithDefault(msg, 17, 0),
    cumulativeStoppedContraDirectionalMicroseconds: jspb.Message.getFieldWithDefault(msg, 18, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.core.ClassFeatures}
 */
proto.vivacity.core.ClassFeatures.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.core.ClassFeatures;
  return proto.vivacity.core.ClassFeatures.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.core.ClassFeatures} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.core.ClassFeatures}
 */
proto.vivacity.core.ClassFeatures.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.vivacity.core.ClassifyingDetectorClassTypes} */ (reader.readEnum());
      msg.setClassType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOccupancy(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCrossingsClockwise(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCrossingsAnticlockwise(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAverageDistanceScalar(value);
      break;
    case 6:
      var value = new vivacity_core_vector_pb.Vector;
      reader.readMessage(value,vivacity_core_vector_pb.Vector.deserializeBinaryFromReader);
      msg.setAverageDisplacement(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStoppedVehiclesCount(value);
      break;
    case 8:
      var value = new vivacity_core_movement_pb.Movement;
      reader.readMessage(value,vivacity_core_movement_pb.Movement.deserializeBinaryFromReader);
      msg.setAverageMovement(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCumulativeStoppedFrames(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDirectionalOccupancy(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setContraDirectionalOccupancy(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStoppedDirectionalVehiclesCount(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStoppedContraDirectionalVehiclesCount(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCumulativeStoppedDirectionalFrames(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCumulativeStoppedContraDirectionalFrames(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCumulativeStoppedMicroseconds(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCumulativeStoppedDirectionalMicroseconds(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCumulativeStoppedContraDirectionalMicroseconds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.core.ClassFeatures.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.core.ClassFeatures.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.core.ClassFeatures} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.ClassFeatures.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClassType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getOccupancy();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCrossingsClockwise();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getCrossingsAnticlockwise();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getAverageDistanceScalar();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getAverageDisplacement();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      vivacity_core_vector_pb.Vector.serializeBinaryToWriter
    );
  }
  f = message.getStoppedVehiclesCount();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getAverageMovement();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      vivacity_core_movement_pb.Movement.serializeBinaryToWriter
    );
  }
  f = message.getCumulativeStoppedFrames();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getDirectionalOccupancy();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getContraDirectionalOccupancy();
  if (f !== 0) {
    writer.writeUint32(
      11,
      f
    );
  }
  f = message.getStoppedDirectionalVehiclesCount();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getStoppedContraDirectionalVehiclesCount();
  if (f !== 0) {
    writer.writeUint32(
      13,
      f
    );
  }
  f = message.getCumulativeStoppedDirectionalFrames();
  if (f !== 0) {
    writer.writeUint32(
      14,
      f
    );
  }
  f = message.getCumulativeStoppedContraDirectionalFrames();
  if (f !== 0) {
    writer.writeUint32(
      15,
      f
    );
  }
  f = message.getCumulativeStoppedMicroseconds();
  if (f !== 0) {
    writer.writeUint32(
      16,
      f
    );
  }
  f = message.getCumulativeStoppedDirectionalMicroseconds();
  if (f !== 0) {
    writer.writeUint32(
      17,
      f
    );
  }
  f = message.getCumulativeStoppedContraDirectionalMicroseconds();
  if (f !== 0) {
    writer.writeUint32(
      18,
      f
    );
  }
};


/**
 * optional ClassifyingDetectorClassTypes class_type = 1;
 * @return {!proto.vivacity.core.ClassifyingDetectorClassTypes}
 */
proto.vivacity.core.ClassFeatures.prototype.getClassType = function() {
  return /** @type {!proto.vivacity.core.ClassifyingDetectorClassTypes} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.vivacity.core.ClassifyingDetectorClassTypes} value
 * @return {!proto.vivacity.core.ClassFeatures} returns this
 */
proto.vivacity.core.ClassFeatures.prototype.setClassType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional uint32 occupancy = 2;
 * @return {number}
 */
proto.vivacity.core.ClassFeatures.prototype.getOccupancy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ClassFeatures} returns this
 */
proto.vivacity.core.ClassFeatures.prototype.setOccupancy = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 crossings_clockwise = 3;
 * @return {number}
 */
proto.vivacity.core.ClassFeatures.prototype.getCrossingsClockwise = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ClassFeatures} returns this
 */
proto.vivacity.core.ClassFeatures.prototype.setCrossingsClockwise = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 crossings_anticlockwise = 4;
 * @return {number}
 */
proto.vivacity.core.ClassFeatures.prototype.getCrossingsAnticlockwise = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ClassFeatures} returns this
 */
proto.vivacity.core.ClassFeatures.prototype.setCrossingsAnticlockwise = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional float average_distance_scalar = 5;
 * @return {number}
 */
proto.vivacity.core.ClassFeatures.prototype.getAverageDistanceScalar = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ClassFeatures} returns this
 */
proto.vivacity.core.ClassFeatures.prototype.setAverageDistanceScalar = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional Vector average_displacement = 6;
 * @return {?proto.vivacity.core.Vector}
 */
proto.vivacity.core.ClassFeatures.prototype.getAverageDisplacement = function() {
  return /** @type{?proto.vivacity.core.Vector} */ (
    jspb.Message.getWrapperField(this, vivacity_core_vector_pb.Vector, 6));
};


/**
 * @param {?proto.vivacity.core.Vector|undefined} value
 * @return {!proto.vivacity.core.ClassFeatures} returns this
*/
proto.vivacity.core.ClassFeatures.prototype.setAverageDisplacement = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.core.ClassFeatures} returns this
 */
proto.vivacity.core.ClassFeatures.prototype.clearAverageDisplacement = function() {
  return this.setAverageDisplacement(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.core.ClassFeatures.prototype.hasAverageDisplacement = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional uint32 stopped_vehicles_count = 7;
 * @return {number}
 */
proto.vivacity.core.ClassFeatures.prototype.getStoppedVehiclesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ClassFeatures} returns this
 */
proto.vivacity.core.ClassFeatures.prototype.setStoppedVehiclesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional Movement average_movement = 8;
 * @return {?proto.vivacity.core.Movement}
 */
proto.vivacity.core.ClassFeatures.prototype.getAverageMovement = function() {
  return /** @type{?proto.vivacity.core.Movement} */ (
    jspb.Message.getWrapperField(this, vivacity_core_movement_pb.Movement, 8));
};


/**
 * @param {?proto.vivacity.core.Movement|undefined} value
 * @return {!proto.vivacity.core.ClassFeatures} returns this
*/
proto.vivacity.core.ClassFeatures.prototype.setAverageMovement = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.core.ClassFeatures} returns this
 */
proto.vivacity.core.ClassFeatures.prototype.clearAverageMovement = function() {
  return this.setAverageMovement(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.core.ClassFeatures.prototype.hasAverageMovement = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional uint32 cumulative_stopped_frames = 9;
 * @return {number}
 */
proto.vivacity.core.ClassFeatures.prototype.getCumulativeStoppedFrames = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ClassFeatures} returns this
 */
proto.vivacity.core.ClassFeatures.prototype.setCumulativeStoppedFrames = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional uint32 directional_occupancy = 10;
 * @return {number}
 */
proto.vivacity.core.ClassFeatures.prototype.getDirectionalOccupancy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ClassFeatures} returns this
 */
proto.vivacity.core.ClassFeatures.prototype.setDirectionalOccupancy = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional uint32 contra_directional_occupancy = 11;
 * @return {number}
 */
proto.vivacity.core.ClassFeatures.prototype.getContraDirectionalOccupancy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ClassFeatures} returns this
 */
proto.vivacity.core.ClassFeatures.prototype.setContraDirectionalOccupancy = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional uint32 stopped_directional_vehicles_count = 12;
 * @return {number}
 */
proto.vivacity.core.ClassFeatures.prototype.getStoppedDirectionalVehiclesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ClassFeatures} returns this
 */
proto.vivacity.core.ClassFeatures.prototype.setStoppedDirectionalVehiclesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional uint32 stopped_contra_directional_vehicles_count = 13;
 * @return {number}
 */
proto.vivacity.core.ClassFeatures.prototype.getStoppedContraDirectionalVehiclesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ClassFeatures} returns this
 */
proto.vivacity.core.ClassFeatures.prototype.setStoppedContraDirectionalVehiclesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional uint32 cumulative_stopped_directional_frames = 14;
 * @return {number}
 */
proto.vivacity.core.ClassFeatures.prototype.getCumulativeStoppedDirectionalFrames = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ClassFeatures} returns this
 */
proto.vivacity.core.ClassFeatures.prototype.setCumulativeStoppedDirectionalFrames = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional uint32 cumulative_stopped_contra_directional_frames = 15;
 * @return {number}
 */
proto.vivacity.core.ClassFeatures.prototype.getCumulativeStoppedContraDirectionalFrames = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ClassFeatures} returns this
 */
proto.vivacity.core.ClassFeatures.prototype.setCumulativeStoppedContraDirectionalFrames = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional uint32 cumulative_stopped_microseconds = 16;
 * @return {number}
 */
proto.vivacity.core.ClassFeatures.prototype.getCumulativeStoppedMicroseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ClassFeatures} returns this
 */
proto.vivacity.core.ClassFeatures.prototype.setCumulativeStoppedMicroseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional uint32 cumulative_stopped_directional_microseconds = 17;
 * @return {number}
 */
proto.vivacity.core.ClassFeatures.prototype.getCumulativeStoppedDirectionalMicroseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ClassFeatures} returns this
 */
proto.vivacity.core.ClassFeatures.prototype.setCumulativeStoppedDirectionalMicroseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional uint32 cumulative_stopped_contra_directional_microseconds = 18;
 * @return {number}
 */
proto.vivacity.core.ClassFeatures.prototype.getCumulativeStoppedContraDirectionalMicroseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.ClassFeatures} returns this
 */
proto.vivacity.core.ClassFeatures.prototype.setCumulativeStoppedContraDirectionalMicroseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


goog.object.extend(exports, proto.vivacity.core);
